import { WhiteBloodCellDifferentialUnitType } from '.';

const BASE_URL = 'https://labsmarts.com/bibliography/#';

export class PanelField {
    static GENERAL_FIELDS = [
        new PanelField({
            id: 'clientId',
            label: 'Client Name',
            placeholder: 'Select Client'
        }),
        new PanelField({
            id: 'collectionDate',
            label: 'Collection Date',
            placeholder: 'MM/DD/YYYY'
        }),
    ];
    //For Add Test Results Panel Fields
    static CBC_FIELDS: Array<PanelField> = [
        new PanelField({
            id: 'whiteBloodCells',
            label: 'WBC (White Blood Cells)',
            shortLabel: 'WBC',
            units: 'k/mcL (x10E3/uL)',
            chartUnits: 'k/mcL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}wbc`,
            useWBCPercentFromMean: true
        }),        
        new PanelField({
            id: 'redBloodCells',
            label: 'RBC (Red Blood Cells)',
            shortLabel: 'RBC',
            units: 'm/mcL (x10E6/uL)',
            chartUnits: 'm/mcL',
            precision: 2,
            labCorpLink: `${BASE_URL}rbc`
        }),
        new PanelField({
            id: 'hemoglobin',
            label: 'HGB (Hemoglobin)',
            shortLabel: 'HGB',
            units: 'g/dL',
            precision: 3,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}hemoglobin`
        }),
        new PanelField({
            id: 'hematocrit',
            label: 'HCT (Hematocrit)',
            shortLabel: 'HCT',
            units: '%',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}hematocrit`
        }),
        new PanelField({
            id: 'meanCorpuscularVolume',
            label: 'MCV (Mean Corpuscular Volume)',
            shortLabel: 'MCV',
            units: 'fL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}mcv`
        }),
        new PanelField({
            id: 'meanCorpuscularHGB',
            label: 'MCH (Mean Corpuscular HGB)',
            shortLabel: 'MCH',
            units: 'pg',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}mch`
        }),
        new PanelField({
            id: 'mchConcentration',
            label: 'MCHC (MCH Concentration)',
            shortLabel: 'MCHC',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}mchc`
        }),
        new PanelField({
            id: 'rbcDistributionWidth',
            label: 'RDW (RBC Distribution Width)',
            shortLabel: 'RDW',
            units: '%',
            precision: 2,
            useRDWChart: true,
            placeholder: 'e.g. 12.1',
            labCorpLink: `${BASE_URL}rdw`
        }),
        new PanelField({
            id: 'plateletCount',
            label: 'Platelet Count',
            shortLabel: 'Platelets',
            units: 'k/mcL (x10E3/uL)',
            chartUnits: 'k/mcL',
            precision: 2,
            placeholderPrecision: 0,
            labCorpLink: `${BASE_URL}platelets`
        }),
        new PanelField({
            id: 'meanPlateletVolume',
            label: 'MPV (Mean Platelet Volume)',
            shortLabel: 'MPV',
            units: 'fL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}mpv`
        }),
        new PanelField({
            id: 'wbcDifferentialUnits',
            label: 'WBC Differential Units',
            isHiddenForDisplay: true,
            isFormCheck: true,
            isHiddenFromComparison: true
        }),
        new PanelField({
            id: 'neutrophils',
            label: 'Neutrophils',
            placeholder: 'e.g. 52',
            absKCellsPlaceholder: 'e.g. 3.14',
            absCellsPlaceholder: 'e.g. 3140',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'lymphocytes',
            label: 'Lymphocytes',
            placeholder: 'e.g. 37',
            absKCellsPlaceholder: 'e.g. 2.18',
            absCellsPlaceholder: 'e.g. 2180',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'monocytes',
            label: 'Monocytes',
            placeholder: 'e.g. 7',
            absKCellsPlaceholder: 'e.g. 0.41',
            absCellsPlaceholder: 'e.g. 410',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'eosinophils',
            label: 'Eosinophils',
            placeholder: 'e.g. 3.2',
            absKCellsPlaceholder: 'e.g. 0.25',
            absCellsPlaceholder: 'e.g. 250',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            noRedChart: true
        }),
        new PanelField({
            id: 'basophils',
            label: 'Basophils',
            placeholder: 'e.g. 0.5',
            absKCellsPlaceholder: 'e.g. 0.04',
            absCellsPlaceholder: 'e.g. 40',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            useRDWChart: true
        })
    ];
    //For Add Test Results Panel Fields
    static CMP_FIELDS = [
        new PanelField({
            id: 'glucose',
            label: 'Glucose',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}glucose`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'bun',
            label: 'BUN (Blood Urea Nitrogen)',
            shortLabel: 'BUN',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}kidney`
        }),
        new PanelField({
            id: 'creatinine',
            label: 'Creatinine',
            units: 'mg/dL',
            precision: 3,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}creatinine`
        }),
        new PanelField({
            id: 'eGFR',
            label: 'eGFR (Non-Afr. American)',
            shortLabel: 'eGFR',
            units: 'mL/min/1.73m2',
            precision: 2,
            labCorpLink: `${BASE_URL}egfr`
        }),
        new PanelField({
            id: 'eGFRforAA',
            label: 'eGFR (African American)',
            shortLabel: 'eGFR',
            units: 'mL/min/1.73m2',
            precision: 2,
            labCorpLink: `${BASE_URL}egfr`
        }),
        new PanelField({
            id: 'bunCreatinineRatio',
            label: 'BUN/Creatinine Ratio',
            shortLabel: 'BUN/Creat Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}buncreatinineratio`
        }),
        new PanelField({
            id: 'sodium',
            label: 'Sodium (Na)',
            shortLabel: 'Sodium',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}electrolytes`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'potassium',
            label: 'Potassium (K)',
            shortLabel: 'Potassium',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}potassium`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'sodiumPotassiumRatio',
            label: 'Sodium/Potassium (Na/K) Ratio',
            shortLabel: 'Na/K Ratio',
            units: 'Ratio',
            precision: 1,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}nakratio`,
            useWBCPercentFromMean: true,
            isHiddenForDisplay: true,
        }),
        new PanelField({
            id: 'chloride',
            label: 'Chloride (CI)',
            shortLabel: 'Chloride',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}chloride`
        }),  
        new PanelField({
            id: 'carbonDioxide',
            label: 'Carbon Dioxide (CO2)',
            shortLabel: 'Carbon Dioxide',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}co2`
        }),
        new PanelField({
            id: 'anionGapWithoutK',
            label: 'Anion Gap [(Na)-(Cl+CO2)]',
            shortLabel: 'Anion Gap',
            units: 'mmol/L',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}aniongap`,
            noRedChart: true
        }),
        new PanelField({
            id: 'anionGap',
            label: 'Anion Gap w/ K',
            shortLabel: 'Anion Gap w/ K',
            units: 'mmol/L',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}aniongap`
        }),
        new PanelField({
            id: 'calcium',
            label: 'Calcium (Ca)',
            shortLabel: 'Calcium (Ca) corr',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}nutrients`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'protein',
            label: 'Protein, Total',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}proteins`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'albumin',
            label: 'Albumin',
            units: 'g/dL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}albumin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'globulin',
            label: 'Globulin',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}globulin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'albuminGlobulinRatio',
            label: 'A/G Ratio',
            units: 'Ratio',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}agratio`
        }),
        new PanelField({
            id: 'bilirubin',
            label: 'Bilirubin, Total',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubintotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'alkalinePhosphatase',
            label: 'Alkaline Phosphatase (ALP)',
            shortLabel: 'Alk Phos',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}alkphos`
        }), 
        new PanelField({
            id: 'ast',
            label: 'AST (SGOT)',
            units: 'U/L',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}ast`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'alt',
            label: 'ALT (SGPT)',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}alt`,
            useWBCPercentFromMean: true
        }),
    ];

    // These are not displayed on Add Test Results
    static WBC_ABSOLUTE_DIFFERENTIALS = [
        new PanelField({
            id: 'neutrophilsAbsolute',
            label: 'Absolute Neutrophils',
            shortLabel: 'Abs Neutro',
            units: 'k/mcL',
            precision: 3,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            isAbsolute: true           
        }),
        new PanelField({
            id: 'lymphocytesAbsolute',
            label: 'Absolute Lymphocytes',
            shortLabel: 'Abs Lympho',
            units: 'k/mcL',
            precision: 3,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            isAbsolute: true 
        }),
        new PanelField({
            id: 'monocytesAbsolute',
            label: 'Absolute Monocytes',
            shortLabel: 'Abs Mono',
            units: 'k/mcL',
            precision: 3,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            isAbsolute: true
        }),
        new PanelField({
            id: 'eosinophilsAbsolute',
            label: 'Absolute Eosinophils',
            shortLabel: 'Abs Eosino',
            units: 'k/mcL',
            precision: 3,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            isAbsolute: true,
            noRedChart: true
        }),
        new PanelField({
            id: 'basophilsAbsolute',
            label: 'Absolute Basophils',
            shortLabel: 'Abs Baso',
            units: 'k/mcL',
            precision: 3,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            isAbsolute: true,
            useRDWChart: true
        }),
        new PanelField({
            id: 'nlr',
            label: 'Neutrophil/Lymphocyte Ratio (NLR)',
            shortLabel: 'NLR',
            units: 'Ratio',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}nlr`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'globulin',
            label: 'Globulin',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}globulin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'alkalinePhosphatase',
            label: 'Alkaline Phosphatase (ALP)',
            shortLabel: 'Alk Phos',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}alkphos`
        }),
    ];
//For Add Test Results Panel Fields
static PLATELETS_FIELDS = [
    new PanelField({
        id: 'plateletCount',
        label: 'Platelet Count',
        shortLabel: 'Platelets',
        units: 'k/mcL (x10E3/uL)',
        chartUnits: 'k/mcL',
        precision: 2,
        placeholderPrecision: 0,
        labCorpLink: `${BASE_URL}platelets`
    }),
    new PanelField({
        id: 'meanPlateletVolume',
        label: 'MPV (Mean Platelet Volume)',
        shortLabel: 'MPV',
        units: 'fL',
        precision: 2,
        placeholderPrecision: 1,
        labCorpLink: `${BASE_URL}mpv`
    }),
    new PanelField({
        id: 'dDimer',
        label: 'D-Dimer',
        units: 'mg/L FEU (μg/mL)',
        chartUnits: 'mg/L FEU',
        precision: 2,
        labCorpLink: `${BASE_URL}d-dimer`,
        useRDWChart: true
    }),
    new PanelField({
        id: 'fibrinogen',
        label: 'Fibrinogen',
        units: 'mg/dL',
        precision: 2,
        labCorpLink: `${BASE_URL}inflammation`,
        useWBCPercentFromMean: true
    }),
    new PanelField({
        id: 'viscosityCapiliaries',
        label: 'Viscosity - Estimated',
        shortLabel: 'Viscosity - Estimated',
        units: 'cP',
        chartUnits: 'cP',
        precision: 2,
        isNotEditable: true, // Calculated from hematocrit + total protein
        wrapChartLabel: true // let "Viscosity - Estimated" wrap to two lines
    }),
];

static GLUCOSE_FIELDS = [
    new PanelField({
        id: 'glucose',
        label: 'Glucose',
        units: 'mg/dL',
        precision: 2,
        labCorpLink: `${BASE_URL}glucose`,
        useWBCPercentFromMean: true
    }),
    new PanelField({
        id: 'hemoglobinA1c',
        label: 'Hemoglobin A1c',
        shortLabel: 'HbA1c',
        units: '%',
        precision: 2,
        labCorpLink: `${BASE_URL}hba1c`,
        useWBCPercentFromMean: true
    }),
    new PanelField({
        id: 'insulin',
        label: 'Insulin',
        units: 'μIU/mL',
        precision: 2,
        labCorpLink: `${BASE_URL}insulin`,
        useWBCPercentFromMean: true
    }),
    new PanelField({
        id: 'cpeptide',
        label: 'C-peptide',
        units: 'ng/mL',
        precision: 2,
        labCorpLink: `${BASE_URL}c-peptide`,
        useWBCPercentFromMean: true
    }),
    new PanelField({
        id: 'amylase',
        label: 'Amylase',
        units: 'U/L',
        precision: 1,
        labCorpLink: `${BASE_URL}amylase`,
        useWBCPercentFromMean: true
    })
];

    // For Add Test Results — Immune & Inflammatory Burden Index (I³) section.
    // Each field holds the client's raw questionnaire subtotal for that section
    // (0..max). `units` shows the per-section max; scored in ImmuneInflammatory.ts.
    static IMMUNE_INFLAMMATORY_FIELDS = [
        new PanelField({ id: 'i3EnergyFatigue', label: 'Energy & Fatigue', units: '/ 20', precision: 0, placeholder: '0–20' }),
        new PanelField({ id: 'i3Infections', label: 'Frequent / Lingering Infections', units: '/ 24', precision: 0, placeholder: '0–24' }),
        new PanelField({ id: 'i3InflammationPain', label: 'Inflammation & Pain', units: '/ 20', precision: 0, placeholder: '0–20' }),
        new PanelField({ id: 'i3GutDigestive', label: 'Oral, Gut & Digestive Health', units: '/ 28', precision: 0, placeholder: '0–28' }),
        new PanelField({ id: 'i3SkinRespiratory', label: 'Skin, Eye & Respiratory Health', units: '/ 28', precision: 0, placeholder: '0–28' }),
        new PanelField({ id: 'i3Musculoskeletal', label: 'Musculoskeletal Health', units: '/ 20', precision: 0, placeholder: '0–20' }),
        new PanelField({ id: 'i3NeuroImmune', label: 'Neuro-Immune Resilience', units: '/ 28', precision: 0, placeholder: '0–28' }),
        new PanelField({ id: 'i3Hormonal', label: 'Hormonal & Endocrine', units: '/ 28', precision: 0, placeholder: '0–28' }),
        new PanelField({ id: 'i3Sensitivities', label: 'Sensitivities & Reactions', units: '/ 16', precision: 0, placeholder: '0–16' }),
        new PanelField({ id: 'i3Biomarkers', label: 'Immune & Inflammatory Biomarkers', units: '/ 12', precision: 0, placeholder: '0–12' }),
    ];

    // Metabolic Vulnerability Index (MVX Plus, Labcorp 123601). Three index scores
    // (entered from the report) + six measured factors. Citrate is mg/dL; the other
    // factors are µmol/L. Scored in src/models/MetabolicVulnerability.ts.
    static MVX_FIELDS = [
        new PanelField({ id: 'mvx', label: 'MVX — Metabolic Vulnerability Index', units: 'score', precision: 0, placeholder: '1–100' }),
        new PanelField({ id: 'ivx', label: 'IVX — Inflammation Vulnerability Index', units: 'score', precision: 0, placeholder: '1–100' }),
        new PanelField({ id: 'mmx', label: 'MMX — Metabolic Malnutrition Index', units: 'score', precision: 0, placeholder: '1–100' }),
        new PanelField({ id: 'glycA', label: 'GlycA', units: 'µmol/L', precision: 0, placeholder: 'e.g. 321' }),
        new PanelField({ id: 'sHdlP', label: 'Small HDL Particle Number', units: 'µmol/L', precision: 1, placeholder: 'e.g. 16.2' }),
        new PanelField({ id: 'citrate', label: 'Citrate', units: 'mg/dL', precision: 2, placeholder: 'e.g. 2.21' }),
        new PanelField({ id: 'valine', label: 'Valine', units: 'µmol/L', precision: 0, placeholder: 'e.g. 236' }),
        new PanelField({ id: 'leucine', label: 'Leucine', units: 'µmol/L', precision: 0, placeholder: 'e.g. 155' }),
        new PanelField({ id: 'isoleucine', label: 'Isoleucine', units: 'µmol/L', precision: 0, placeholder: 'e.g. 91' }),
    ];

    //For Add Test Results Lipdis Panel Section
    static LIPID_FIELDS = [
        new PanelField({
            id: 'cholesterol',
            label: 'Cholesterol, Total',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}lipids`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hdl',
            label: 'HDL Cholesterol',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}hdl`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'triglycerides',
            label: 'Triglycerides',
            shortLabel: 'Triglycerides (TG)',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerides`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ldl',
            label: 'LDL Cholesterol',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ldl`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cholesterolHDLRatio',
            label: 'Cholesterol/HDL Ratio',
            shortLabel: 'Chol/HDL Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}cholesterolhdlratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'triglyceridesHDLRatio',
            label: 'Triglycerides/HDL Ratio',
            shortLabel: 'TG/HDL Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerideshdlratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'apolipoproteinA1',
            label: 'Apolipoprotein A-1 (Apo A-1)',
            shortLabel: 'Apo A-1',
            units: 'mg/dL',
            precision: 0,
            labCorpLink: `${BASE_URL}apolipoproteina1`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'apolipoproteinB',
            label: 'Apolipoprotein B (Apo B)',
            shortLabel: 'Apo B',
            units: 'mg/dL',
            precision: 0,
            labCorpLink: `${BASE_URL}apolipoproteinb`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'apoBapoA1Ratio',
            label: 'Apo B/Apo A-1',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}apobapoa1ratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'lipoproteinA',
            label: 'Lipoprotein(a)',
            units: 'nmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}lipoproteina`,
            useRDWChart: true
        }),
    ];
    //For Add Test Results Panel Fields
    static IRON_FIELDS = [
        new PanelField({
            id: 'iron',
            label: 'Iron, Total',
            shortLabel: 'Iron',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}iron`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'tibc',
            label: 'TIBC (Total Iron Binding Capacity)',
            shortLabel: 'TIBC',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}tibc`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'saturation',
            label: '% Saturation',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}transferrinsaturation`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ferritin',
            label: 'Ferritin',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}ferritin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'transferrin',
            label: 'Transferrin',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}transferrin`,
            useWBCPercentFromMean: true
        })
    ];
    //This is for the Additional Markers section in Add Test Results
    static ADDITIONAL_FIELDS1 = [
        new PanelField({
            id: 'amylase',
            label: 'Amylase',
            units: 'U/L',
            precision: 1,
            labCorpLink: `${BASE_URL}amylase`,
            useWBCPercentFromMean: true
        }),

        new PanelField({
            id: 'bileAcids',
            label: 'Bile Acids',
            units: 'μmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}liver`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'bilirubinDirect',
            label: 'Bilirubin, Direct',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubindirect`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'bilirubinIndirect',
            label: 'Bilirubin, Indirect',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubinindirect`,
            noRedChart: true
        }),
        new PanelField({
            id: 'ceruloplasmin',
            label: 'Ceruloplasmin',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ceruloplasmin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'copperRBCμgmL',
            label: 'Copper, RBC',
            units: 'μg/mL (mcg/mL, mg/L)',
            chartUnits: 'μg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperRBCμgdL',
            label: 'Copper, RBC',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerumμgdL',
            label: 'Copper, serum',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerummcgmL',
            label: 'Copper, serum',
            units: 'mcg/mL (μg/mL, mg/L)',
            chartUnits: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperZincRatio',
            label: 'Cu/Zn Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}copperzincratio`,
            isNotEditable: true,
            isHiddenForDisplay: true,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'percentOfFreeCopper',
            label: 'Free Copper',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}percentoffreecopper`,
            isNotEditable: true,
            isHiddenForDisplay: true,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'cpeptide',
            label: 'C-peptide',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}c-peptide`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'dDimer',
            label: 'D-Dimer',
            units: 'mg/L FEU (μg/mL)',
            chartUnits: 'mg/L FEU',
            precision: 2,
            labCorpLink: `${BASE_URL}d-dimer`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'fibrinogen',
            label: 'Fibrinogen',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}inflammation`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'viscosityCapiliaries',
            label: 'Viscosity - Estimated',
            shortLabel: 'Viscosity - Estimated',
            units: 'cP',
            chartUnits: 'cP',
            precision: 2,
            isNotEditable: true, // Calculated from hematocrit + total protein
            wrapChartLabel: true // let "Viscosity - Estimated" wrap to two lines
        }),
        new PanelField({
            id: 'folateRBC',
            label: 'Folate, RBC',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}folateRBC`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'folateSerum',
            label: 'Folate, serum',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}folateSerum`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ggt',
            label: 'Gamma Glutamyl Transferase (GGT)',
            shortLabel: 'GGT',
            units: 'UL',
            precision: 2,
            labCorpLink: `${BASE_URL}ggt`,
            noRedChart: true
        }),
        new PanelField({
            id: 'hemoglobinA1c',
            label: 'Hemoglobin A1c',
            shortLabel: 'HbA1c',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}hba1c`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'homocysteine',
            label: 'Homocysteine',
            units: 'μmol/L',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}homocysteine`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hsCRP',
            label: 'hs-CRP',
            units: 'mg/L',
            precision: 2,
            labCorpLink: `${BASE_URL}hs-crp`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'insulin',
            label: 'Insulin',
            units: 'μIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}insulin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'lactateDehydrogenase',
            label: 'Lactate Dehydrogenase  (LDH, LD)',
            shortLabel: 'LDH, LD',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}ldh`
        })
    ];
    //For Add Test Results Panel Fields
    static ADDITIONAL_FIELDS2 = [
        new PanelField({
            id: 'magnesiumRBC',
            label: 'Magnesium, RBC',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}magnesiumRBC`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'magnesium',
            label: 'Magnesium, serum',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}magnesium`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'phosphorus',
            label: 'Phosphorus',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}phosphorus`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'psaTotal',
            label: 'Prostate-Specific Antigen (PSA), Total',
            units: 'ng/mL',
            placeholder: 'e.g. 0.9',
            precision: 2,
            shortLabel: 'PSA, Total',
            labCorpLink: `${BASE_URL}psatotal`,
            useRDWChart: true
        }),
       new PanelField({
            id: 'psaFree',
            label: 'Prostate-Specific Antigen (PSA), Free',
            units: 'ng/mL',
            placeholder: 'e.g. 0.48',
            precision: 3,
            shortLabel: 'PSA, Free',
            labCorpLink: `${BASE_URL}psafree`,
            useEGFRChart: true
        }),
        new PanelField({
            id: 'psaFreePercent',
            label: 'Prostate-Specific Antigen (PSA), % Free',
            units: '%',
            placeholder: 'e.g. 26',
            precision: 2,
            shortLabel: 'PSA, % Free',
            labCorpLink: `${BASE_URL}psafreepercent`,
            useEGFRChart: true
        }),
        new PanelField({
            id: 'reticulocyteCount',
            label: 'Reticulocyte Count',
            shortLabel: 'CRC',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}reticulocytes`,
            noRedChart: true
        }),     
        new PanelField({
            id: 'RPI',
            label: 'RPI',
            units: '',
            precision: 2,
            labCorpLink: `${BASE_URL}rpi`,
            isNotEditable: true,
            useWBCPercentFromMean: true,
            isHiddenForDisplay: true
        }),
        new PanelField({
            id: 'esr',
            label: 'Sedimentation Rate (Erythrocyte Sed Rate, ESR)',
            shortLabel: 'Sed Rate (ESR)',
            units: 'mm/h',
            precision: 2,
            labCorpLink: `${BASE_URL}esr`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'uricAcid',
            label: 'Uric Acid',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}uricacid`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminA',
            label: 'Vitamin A (Retinol), serum',
            shortLabel: 'Vitamin A',
            units: 'μg/dL',
            precision: 1,
            labCorpLink: `${BASE_URL}vitamina`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminB6',
            label: 'Vitamin B6, plasma',
            shortLabel: 'Vitamin B6',
            units: 'μg/L',
            precision: 1,
            labCorpLink: `${BASE_URL}vitaminb6`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminB12',
            label: 'Vitamin B12, serum',
            shortLabel: 'Vitamin B12',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitaminb12`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminD',
            label: 'Vitamin D (25-OH)',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitamind`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminD125',
            label: 'Vitamin D, 1,25 (OH)2',
            shortLabel: 'Vit D 1,25 (OH)2',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitamind125`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'zincRBCμgdL',
            label: 'Zinc, RBC',
            units: 'μg/dL (mcg/dL)', // Use the default here
            chartUnits: 'μg/dL', // Use the default here
            precision: 2,
            labCorpLink: `${BASE_URL}zincRBC`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincRBCmgL',
            label: 'Zinc, RBC',
            units: 'mg/L (µg/mL, mcg/mL)',
            chartUnits: 'mg/L',
            precision: 2,
            labCorpLink: `${BASE_URL}zincRBC`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincSerumμgdL',
            label: 'Zinc, serum or plasma',
            shortLabel: 'Zinc, serum',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}zincSerum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincSerummcgmL',
            label: 'Zinc, serum or plasma',
            shortLabel: 'Zinc, serum',
            units: 'mcg/mL (μg/mL, mg/L)',
            chartUnits: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}zincSerum`,
            useWBCPercentFromMean: true,
        })
    ];
    static ADDITIONAL_FIELDS = [...PanelField.ADDITIONAL_FIELDS1, ...PanelField.ADDITIONAL_FIELDS2]
    //For Add Test Results Panel Fields
    static THYROID_FIELDS = [
        new PanelField({
            id: 'tsh',
            label: 'TSH',
            units: 'μIU/mL (mIU/L)',
            chartUnits: 'μIU/mL',
            precision: 3,
            labCorpLink: `${BASE_URL}thyroid`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 't4Total',
            label: 'T4 (Thyroxine), Total',
            shortLabel: 'T4, Total',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}T4Total`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 't4Free',
            label: 'T4, Free',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}T4Free`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 't3Total',
            label: 'T3 (Triiodothyronine), Total',
            shortLabel: 'T3, Total',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}T3Total`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 't3Free',
            label: 'T3, Free',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}T3Free`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'reverseT3',
            label: 'Reverse T3',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ReverseT3`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'tpoAb',
            label: 'Thyroid Peroxidase Antibodies (TPO Ab)',
            shortLabel: 'TPO Ab',
            units: 'IU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}TPOAb`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'tgAb',
            label: 'Thyroglobulin Antibodies (Tg Ab)',
            shortLabel: 'Tg Ab',
            units: 'IU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}TgAb`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'tbg',
            label: 'Thyroxine Binding Globulin (TBG)',
            shortLabel: 'TBG',
            units: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}TBG`
        }),
        new PanelField({
            id: 't3Uptake',
            label: 'T3 Uptake',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}T3Uptake`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'freeT4Index',
            label: 'Free Thyroxine (T4) Index (FTI, T7)',
            shortLabel: 'FTI',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}FTI`,
            useWBCPercentFromMean: true
        })
    ];
    //For Add Test Results Panel Fields
    static SEX_HORMONE_FIELDS = [
        new PanelField({
            id: 'menstrualPhase',
            label: 'Menstrual Phase',
            placeholder: 'Select Menstrual Phase'
        }),
        new PanelField({
            id: 'antiMullerianHormone',
            label: 'Anti-Mullerian Hormone (AMH)',
            shortLabel: 'AMH',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}amh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cortisolAM',
            label: 'Cortisol, AM',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}cortisolam`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cortisolPM',
            label: 'Cortisol, PM',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}cortisolpm`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'dheaS',
            label: 'DHEA Sulfate',
            shortLabel: 'DHEA-S',
            units: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}dhea`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'dihydrotestosterone',
            label: 'Dihydrotestosterone (DHT)',
            shortLabel: 'DHT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}dihydrotestosterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estradiolE2',
            label: 'Estradiol, E2',
            shortLabel: 'Estradiol (E2)',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estradiol`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estriolE3',
            label: 'Estriol, E3',
            shortLabel: 'Estriol (E3)',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estriol`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estrogensTotal',
            label: 'Estrogens, Total',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estrogenstotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estroneE1',
            label: 'Estrone, E1',
            shortLabel: 'Estrone (E1)',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estrone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'fsh',
            label: 'Follicle Stimulating Hormone (FSH)',
            shortLabel: 'FSH',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}fsh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hCG',
            label: 'Human Chorionic Gonadotropin (hCG)',
            shortLabel: 'hCG',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}hcg`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'igf1',
            label: 'Insulin-like Growth Factor-1 (IGF-1)',
            shortLabel: 'IGF-1',
            units: 'ng/mL',
            precision: 1,
            labCorpLink: `${BASE_URL}igf1`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'lh',
            label: 'Luteinizing Hormone (LH)',
            shortLabel: 'LH',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}lh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'pregnenolone',
            label: 'Pregnenolone, LC/MS',
            shortLabel: 'Pregnenolone',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}pregnenolone-lc-ms`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'progesterone',
            label: 'Progesterone',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}progesterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hydroxyprogesterone17',
            label: '17-Hydroxyprogesterone (17-OHP)',
            shortLabel: '17-OHP',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}17hydroxyprogesterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'prolactin',
            label: 'Prolactin',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}prolactin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'prolactinLactating',
            label: 'Prolactin, Lactating',
            shortLabel: 'Prolactin, Lact',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}prolactin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'shbg',
            label: 'Sex Hormone Binding Globulin (SHBG)',
            shortLabel: 'SHBG',
            units: 'nmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}shbg`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneBioavailable',
            label: 'Testosterone, Bioavailable (Free + Weakly Bound)',
            shortLabel: 'BioT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronebioavailable`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneBioavailablePercent',
            label: 'Testosterone, Bioavailable (Free + Weakly Bound) %',
            shortLabel: 'BioT %',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronebioavailablepercent`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneFreeCalc',
            label: 'Testosterone, Free, Calc',
            shortLabel: 'FreeT, Calc',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronefreecalc`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneFreeDirect',
            label: 'Testosterone, Free, Direct',
            shortLabel: 'FreeT, Direct',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronefreedirect`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneTotal',
            label: 'Testosterone, Total',
            shortLabel: 'TotalT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronetotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneTotalLCMS',
            label: 'Testosterone, Total, LC/MS',
            shortLabel: 'TotalT, LC/MS',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronetotallcms`,
            useWBCPercentFromMean: true
        }),
    ];
    //For Test Results Analysis Bar Graph Groupings
    static RBC_FIELDS: Array<PanelField> = [     
        new PanelField({
            id: 'redBloodCells',
            label: 'RBC (Red Blood Cells)',
            shortLabel: 'RBC',
            units: 'm/mcL (x10E6/uL)',
            chartUnits: 'm/mcL',
            precision: 2,
            labCorpLink: `${BASE_URL}rbc`
        }),
        new PanelField({
            id: 'hemoglobin',
            label: 'HGB (Hemoglobin)',
            shortLabel: 'HGB',
            units: 'g/dL',
            precision: 3,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}hemoglobin`
        }),
        new PanelField({
            id: 'hematocrit',
            label: 'HCT (Hematocrit)',
            shortLabel: 'HCT',
            units: '%',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}hematocrit`
        }),
        new PanelField({
            id: 'meanCorpuscularVolume',
            label: 'MCV (Mean Corpuscular Volume)',
            shortLabel: 'MCV',
            units: 'fL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}mcv`
        }),
        new PanelField({
            id: 'meanCorpuscularHGB',
            label: 'MCH (Mean Corpuscular HGB)',
            shortLabel: 'MCH',
            units: 'pg',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}mch`
        }),
        new PanelField({
            id: 'mchConcentration',
            label: 'MCHC (MCH Concentration)',
            shortLabel: 'MCHC',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}mchc`
        }),
        new PanelField({
            id: 'rbcDistributionWidth',
            label: 'RDW (RBC Distribution Width)',
            shortLabel: 'RDW',
            units: '%',
            precision: 2,
            useRDWChart: true,
            placeholder: 'e.g. 12.1',
            labCorpLink: `${BASE_URL}rdw`
        }),
        new PanelField({
            id: 'reticulocyteCount',
            label: 'Reticulocyte Count',
            shortLabel: 'CRC',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}reticulocytes`,
            noRedChart: true
        }),
        new PanelField({
            id: 'RPI',
            label: 'RPI',
            units: '',
            precision: 2,
            labCorpLink: `${BASE_URL}rpi`,
            isNotEditable: true,
            useWBCPercentFromMean: true,
            isHiddenForDisplay: true
        })
    ];
    //For Test Results Analysis Bar Graph Groupings - Gets added to the Iron Analysis section - 9/9/25 - adding Vitamin A
    static COPPER_FIELDS: Array<PanelField> = [     
        new PanelField({
            id: 'ceruloplasmin',
            label: 'Ceruloplasmin',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ceruloplasmin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'copperRBCμgmL',
            label: 'Copper, RBC',
            units: 'μg/mL (mcg/mL, mg/L)',
            chartUnits: 'μg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperRBCμgdL',
            label: 'Copper, RBC',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerumμgdL',
            label: 'Copper, serum',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerummcgmL',
            label: 'Copper, serum',
            units: 'mcg/mL (μg/mL, mg/L)',
            chartUnits: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'percentOfFreeCopper',
            label: 'Free Copper',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}percentoffreecopper`,
            isNotEditable: true,
            isHiddenForDisplay: true,
            useWBCPercentFromMean: true,
        }),
            new PanelField({
            id: 'vitaminA',
            label: 'Vitamin A (Retinol), serum',
            shortLabel: 'Vitamin A',
            units: 'μg/dL',
            precision: 1,
            labCorpLink: `${BASE_URL}vitamina`,
            useWBCPercentFromMean: true
        }),
    ];

    //For Test Results Analysis Bar Graph Groupings
    static IMMUNE_SYSTEM_FIELDS: Array<PanelField> = [
        new PanelField({
            id: 'whiteBloodCells',
            label: 'WBC (White Blood Cells)',
            shortLabel: 'WBC',
            units: 'k/mcL (x10E3/uL)',
            chartUnits: 'k/mcL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}wbc`,
            useWBCPercentFromMean: true
        }),        
        new PanelField({
            id: 'wbcDifferentialUnits',
            label: 'WBC Differential Units',
            isHiddenForDisplay: true,
            isFormCheck: true,
            isHiddenFromComparison: true
        }),
        new PanelField({
            id: 'neutrophils',
            label: 'Neutrophils',
            placeholder: 'e.g. 52',
            absKCellsPlaceholder: 'e.g. 3.14',
            absCellsPlaceholder: 'e.g. 3140',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'lymphocytes',
            label: 'Lymphocytes',
            placeholder: 'e.g. 37',
            absKCellsPlaceholder: 'e.g. 2.18',
            absCellsPlaceholder: 'e.g. 2180',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'monocytes',
            label: 'Monocytes',
            placeholder: 'e.g. 7',
            absKCellsPlaceholder: 'e.g. 0.41',
            absCellsPlaceholder: 'e.g. 410',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true
        }),
        new PanelField({
            id: 'eosinophils',
            label: 'Eosinophils',
            placeholder: 'e.g. 3.2',
            absKCellsPlaceholder: 'e.g. 0.25',
            absCellsPlaceholder: 'e.g. 250',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            noRedChart: true
        }),
        new PanelField({
            id: 'basophils',
            label: 'Basophils',
            placeholder: 'e.g. 0.5',
            absKCellsPlaceholder: 'e.g. 0.04',
            absCellsPlaceholder: 'e.g. 40',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}differentials`,
            isWBCDifferential: true,
            useRDWChart: true
        }),
    ];
    //For Test Results Analysis Bar Graph Groupings
    static KIDNEY_FIELDS = [
        new PanelField({
            id: 'bun',
            label: 'BUN (Blood Urea Nitrogen)',
            shortLabel: 'BUN',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}kidney`
        }),
        new PanelField({
            id: 'creatinine',
            label: 'Creatinine',
            units: 'mg/dL',
            precision: 3,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}creatinine`
        }),
        new PanelField({
            id: 'eGFR',
            label: 'eGFR (Non-Afr. American)',
            shortLabel: 'eGFR',
            units: 'mL/min/1.73m2',
            precision: 2,
            labCorpLink: `${BASE_URL}egfr`
        }),
        new PanelField({
            id: 'eGFRforAA',
            label: 'eGFR (African American)',
            shortLabel: 'eGFR AA',
            units: 'mL/min/1.73m2',
            precision: 2,
            labCorpLink: `${BASE_URL}egfr`
        }),
        new PanelField({
            id: 'bunCreatinineRatio',
            label: 'BUN/Creatinine Ratio',
            shortLabel: 'BUN/Creat Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}buncreatinineratio`
        }),
        new PanelField({
            id: 'uricAcid',
            label: 'Uric Acid',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}uricacid`,
            useWBCPercentFromMean: true
        })
    ];
    //For Test Results Analysis Bar Graph Groupings
    static NUTRIENTS_FIELDS = [
        new PanelField({
            id: 'calcium',
            label: 'Calcium (Ca)',
            shortLabel: 'Calcium (Ca) corr',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}nutrients`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ceruloplasmin',
            label: 'Ceruloplasmin',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ceruloplasmin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'copperRBCμgmL',
            label: 'Copper, RBC',
            units: 'μg/mL (mcg/mL, mg/L)',
            chartUnits: 'μg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperRBCμgdL',
            label: 'Copper, RBC',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperrbc`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerumμgdL',
            label: 'Copper, serum',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperSerummcgmL',
            label: 'Copper, serum',
            units: 'mcg/mL (μg/mL, mg/L)',
            chartUnits: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}copperserum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'copperZincRatio',
            label: 'Cu/Zn Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}copperzincratio`,
            isNotEditable: true,
            isHiddenForDisplay: true,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'percentOfFreeCopper',
            label: 'Free Copper',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}percentoffreecopper`,
            isNotEditable: true,
            isHiddenForDisplay: true,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'folateRBC',
            label: 'Folate, RBC',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}folateRBC`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'folateSerum',
            label: 'Folate, serum',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}folateSerum`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'magnesiumRBC',
            label: 'Magnesium, RBC',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}magnesiumRBC`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'magnesium',
            label: 'Magnesium, serum',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}magnesium`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'phosphorus',
            label: 'Phosphorus',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}phosphorus`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminA',
            label: 'Vitamin A (Retinol), serum',
            shortLabel: 'Vitamin A',
            units: 'μg/dL',
            precision: 1,
            labCorpLink: `${BASE_URL}vitamina`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminB6',
            label: 'Vitamin B6, plasma',
            shortLabel: 'Vitamin B6',
            units: 'μg/L',
            precision: 1,
            labCorpLink: `${BASE_URL}vitaminb6`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminB12',
            label: 'Vitamin B12, serum',
            shortLabel: 'Vitamin B12',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitaminb12`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminD',
            label: 'Vitamin D (25-OH)',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitamind`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'vitaminD125',
            label: 'Vitamin D, 1,25 (OH)2',
            shortLabel: 'Vit D 1,25 (OH)2',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}vitamind125`,
            useWBCPercentFromMean: true
        })
    ];
        //For Test Results Analysis Bar Graphs - gets added to the Vitamin & Mineral Status section
        static ZINC_FIELDS = [
        new PanelField({
            id: 'zincRBCμgdL',
            label: 'Zinc, RBC',
            units: 'μg/dL (mcg/dL)', // Use the default here
            chartUnits: 'μg/dL', // Use the default here
            precision: 2,
            labCorpLink: `${BASE_URL}zincRBC`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincRBCmgL',
            label: 'Zinc, RBC',
            units: 'mg/L (µg/mL, mcg/mL)',
            chartUnits: 'mg/L',
            precision: 2,
            labCorpLink: `${BASE_URL}zincRBC`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincSerumμgdL',
            label: 'Zinc, serum or plasma',
            shortLabel: 'Zinc, serum',
            units: 'μg/dL (mcg/dL)',
            chartUnits: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}zincSerum`,
            useWBCPercentFromMean: true,
        }),
        new PanelField({
            id: 'zincSerummcgmL',
            label: 'Zinc, serum or plasma',
            shortLabel: 'Zinc, serum',
            units: 'mcg/mL (μg/mL, mg/L)',
            chartUnits: 'mcg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}zincSerum`,
            useWBCPercentFromMean: true,
        }),
    ];

    static ELECTROLYTES_FIELDS = [
        new PanelField({
            id: 'sodium',
            label: 'Sodium (Na)',
            shortLabel: 'Sodium',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}electrolytes`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'potassium',
            label: 'Potassium (K)',
            shortLabel: 'Potassium',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}potassium`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'sodiumPotassiumRatio',
            label: 'Sodium/Potassium (Na/K) Ratio',
            shortLabel: 'Na/K Ratio',
            units: 'Ratio',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}nakratio`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'chloride',
            label: 'Chloride (CI)',
            shortLabel: 'Chloride',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}chloride`
        }),  
        new PanelField({
            id: 'carbonDioxide',
            label: 'Carbon Dioxide (CO2)',
            shortLabel: 'Carbon Dioxide',
            units: 'mmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}co2`
        }),
        new PanelField({
            id: 'anionGapWithoutK',
            label: 'Anion Gap [(Na)-(Cl+CO2)]',
            shortLabel: 'Anion Gap',
            units: 'mmol/L',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}aniongap`,
            noRedChart: true
        }),
        new PanelField({
            id: 'anionGap',
            label: 'Anion Gap w/ K',
            shortLabel: 'Anion Gap w/ K',
            units: 'mmol/L',
            precision: 2,
            isNotEditable: true,
            labCorpLink: `${BASE_URL}aniongap`
        }),
    ];

    static PROTEINS_FIELDS = [
        new PanelField({
            id: 'protein',
            label: 'Protein, Total',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}proteins`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'albumin',
            label: 'Albumin',
            units: 'g/dL',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}albumin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'globulin',
            label: 'Globulin',
            units: 'g/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}globulin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'albuminGlobulinRatio',
            label: 'A/G Ratio',
            units: 'Ratio',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}agratio`
        }),
    ];
    //This is for the Liver Markers section in the Comparison Table
    static LIVER_FIELDS = [
        new PanelField({
            id: 'bileAcids',
            label: 'Bile Acids',
            units: 'μmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}liver`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'bilirubin',
            label: 'Bilirubin, Total',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubintotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'bilirubinDirect',
            label: 'Bilirubin, Direct',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubindirect`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'bilirubinIndirect',
            label: 'Bilirubin, Indirect',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}bilirubinindirect`,
            noRedChart: true
        }),
        new PanelField({
            id: 'alkalinePhosphatase',
            label: 'Alkaline Phosphatase (ALP)',
            shortLabel: 'Alk Phos',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}alkphos`
        }), 
        new PanelField({
            id: 'ast',
            label: 'AST (SGOT)',
            units: 'U/L',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}ast`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'alt',
            label: 'ALT (SGPT)',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}alt`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ggt',
            label: 'Gamma Glutamyl Transferase (GGT)',
            shortLabel: 'GGT',
            units: 'UL',
            precision: 2,
            labCorpLink: `${BASE_URL}ggt`,
            noRedChart: true
        }),
        new PanelField({
            id: 'lactateDehydrogenase',
            label: 'Lactate Dehydrogenase  (LDH, LD)',
            shortLabel: 'LDH, LD',
            units: 'U/L',
            precision: 2,
            labCorpLink: `${BASE_URL}ldh`
        })
    ];
    //This is for the Comparison Table Section — lipid markers only.
    static COMPARISON_LIPIDS_FIELDS = [
        new PanelField({
            id: 'cholesterol',
            label: 'Cholesterol, Total',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}lipids`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hdl',
            label: 'HDL Cholesterol',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}hdl`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'triglycerides',
            label: 'Triglycerides',
            shortLabel: 'Triglycerides (TG)',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerides`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'ldl',
            label: 'LDL Cholesterol',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}ldl`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cholesterolHDLRatio',
            label: 'Cholesterol/HDL Ratio',
            shortLabel: 'Chol/HDL Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}cholesterolhdlratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'triglyceridesHDLRatio',
            label: 'Triglycerides/HDL Ratio',
            shortLabel: 'TG/HDL Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerideshdlratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'apolipoproteinA1',
            label: 'Apolipoprotein A-1 (Apo A-1)',
            shortLabel: 'Apo A-1',
            units: 'mg/dL',
            precision: 0,
            labCorpLink: `${BASE_URL}apolipoproteina1`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'apolipoproteinB',
            label: 'Apolipoprotein B (Apo B)',
            shortLabel: 'Apo B',
            units: 'mg/dL',
            precision: 0,
            labCorpLink: `${BASE_URL}apolipoproteinb`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'apoBapoA1Ratio',
            label: 'Apo B/Apo A-1',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}apobapoa1ratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'lipoproteinA',
            label: 'Lipoprotein(a)',
            units: 'nmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}lipoproteina`,
            useRDWChart: true
        }),
    ];
    //This is for the Comparison Table Section — inflammation & oxidative stress markers only.
    static COMPARISON_INFLAMMATION_FIELDS = [
        new PanelField({
            id: 'homocysteine',
            label: 'Homocysteine',
            units: 'μmol/L',
            precision: 2,
            placeholderPrecision: 1,
            labCorpLink: `${BASE_URL}homocysteine`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hsCRP',
            label: 'hs-CRP',
            units: 'mg/L',
            precision: 2,
            labCorpLink: `${BASE_URL}hs-crp`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'esr',
            label: 'Sedimentation Rate (Erythrocyte Sed Rate, ESR)',
            shortLabel: 'Sed Rate (ESR)',
            units: 'mm/h',
            precision: 2,
            labCorpLink: `${BASE_URL}esr`,
            useWBCPercentFromMean: true
        })
    ];
    //Combined lipids + inflammation list (legacy alias kept for backward compatibility).
    static LIPIDS_INFLAM_FIELDS = [
        ...PanelField.COMPARISON_LIPIDS_FIELDS,
        ...PanelField.COMPARISON_INFLAMMATION_FIELDS,
    ];
//This is for adding these 3 markers to the Glucose section in the Comparison table
    static GLUCOSE_TG_HDL_SECTION_FIELDS = [
        new PanelField({
            id: 'triglyceridesHDLRatio',
            label: 'Triglycerides/HDL Ratio',
            shortLabel: 'TG/HDL Ratio',
            units: 'Ratio',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerideshdlratio`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'triglycerides',
            label: 'Triglycerides',
            shortLabel: 'Triglycerides (TG)',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}triglycerides`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hdl',
            label: 'HDL Cholesterol',
            units: 'mg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}hdl`,
            useWBCPercentFromMean: true
        }),
    ];

    static HORMONE_FIELDS_1 = [
        new PanelField({
            id: 'menstrualPhase',
            label: 'Menstrual Phase',
            placeholder: 'Select Menstrual Phase'
        }),
        new PanelField({
            id: 'antiMullerianHormone',
            label: 'Anti-Mullerian Hormone (AMH)',
            shortLabel: 'AMH',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}amh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cortisolAM',
            label: 'Cortisol, AM',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}cortisolam`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'cortisolPM',
            label: 'Cortisol, PM',
            units: 'mcg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}cortisolpm`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'dheaS',
            label: 'DHEA Sulfate',
            shortLabel: 'DHEA-S',
            units: 'μg/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}dhea`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'dihydrotestosterone',
            label: 'Dihydrotestosterone (DHT)',
            shortLabel: 'DHT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}dihydrotestosterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estradiolE2',
            label: 'Estradiol, E2',
            shortLabel: 'Estradiol (E2)',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estradiol`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estriolE3',
            label: 'Estriol, E3',
            shortLabel: 'Estriol (E3)',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estriol`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estrogensTotal',
            label: 'Estrogens, Total',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estrogenstotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'estroneE1',
            label: 'Estrone, E1',
            shortLabel: 'Estrone (E1)',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}estrone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'fsh',
            label: 'Follicle Stimulating Hormone (FSH)',
            shortLabel: 'FSH',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}fsh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hCG',
            label: 'Human Chorionic Gonadotropin (hCG)',
            shortLabel: 'hCG',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}hcg`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'igf1',
            label: 'Insulin-like Growth Factor-1 (IGF-1)',
            shortLabel: 'IGF-1',
            units: 'ng/mL',
            precision: 1,
            labCorpLink: `${BASE_URL}igf1`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'lh',
            label: 'Luteinizing Hormone (LH)',
            shortLabel: 'LH',
            units: 'mIU/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}lh`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'pregnenolone',
            label: 'Pregnenolone, LC/MS',
            shortLabel: 'Pregnenolone',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}pregnenolone-lc-ms`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'progesterone',
            label: 'Progesterone',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}progesterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'hydroxyprogesterone17',
            label: '17-Hydroxyprogesterone (17-OHP)',
            shortLabel: '17-OHP',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}17hydroxyprogesterone`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'prolactin',
            label: 'Prolactin',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}prolactin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'prolactinLactating',
            label: 'Prolactin, Lactating',
            shortLabel: 'Prolactin, Lact',
            units: 'ng/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}prolactin`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'shbg',
            label: 'Sex Hormone Binding Globulin (SHBG)',
            shortLabel: 'SHBG',
            units: 'nmol/L',
            precision: 2,
            labCorpLink: `${BASE_URL}shbg`,
            useWBCPercentFromMean: true
        })
    ];

    //This is for the Prostate Markers section in the Comparison Table
    static PROSTATE_FIELDS = [
            new PanelField({
            id: 'psaTotal',
            label: 'Prostate-Specific Antigen (PSA), Total',
            units: 'ng/mL',
            precision: 2,
            shortLabel: 'PSA, Total',
            labCorpLink: `${BASE_URL}psaTotal`,
            useRDWChart: true
        }),
        new PanelField({
            id: 'psaFree',
            label: 'Prostate-Specific Antigen (PSA), Free',
            units: 'ng/mL',
            precision: 3,
            shortLabel: 'PSA, Free',
            labCorpLink: `${BASE_URL}psaFree`,
            useEGFRChart: true
        }),
        new PanelField({
            id: 'psaFreePercent',
            label: 'Prostate-Specific Antigen (PSA), % Free',
            units: '%',
            precision: 2,
            shortLabel: 'PSA, % Free',
            labCorpLink: `${BASE_URL}psaFreePercent`,
            useEGFRChart: true
        }),
    ];
    //This was for the separate Testosterone section we had in the comparison table but now it goes in the Hormones Markers section in the comparison table
    static HORMONE_FIELDS_2 = [
        new PanelField({
            id: 'testosteroneBioavailable',
            label: 'Testosterone, Bioavailable (Free + Weakly Bound)',
            shortLabel: 'BioT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronebioavailable`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneBioavailablePercent',
            label: 'Testosterone, Bioavailable (Free + Weakly Bound) %',
            shortLabel: 'BioT %',
            units: '%',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronebioavailablepercent`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneFreeCalc',
            label: 'Testosterone, Free, Calc',
            shortLabel: 'FreeT, Calc',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronefreecalc`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneFreeDirect',
            label: 'Testosterone, Free, Direct',
            shortLabel: 'FreeT, Direct',
            units: 'pg/mL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronefreedirect`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneTotal',
            label: 'Testosterone, Total',
            shortLabel: 'TotalT',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronetotal`,
            useWBCPercentFromMean: true
        }),
        new PanelField({
            id: 'testosteroneTotalLCMS',
            label: 'Testosterone, Total, LC/MS',
            shortLabel: 'TotalT, LC/MS',
            units: 'ng/dL',
            precision: 2,
            labCorpLink: `${BASE_URL}testosteronetotallcms`,
            useWBCPercentFromMean: true
        })
    ];

    // Stress & Adrenal Balance comparison fields: Na/K ratio + Na/K context
    // (from Electrolytes) + adrenal hormones (from Hormones). Mirrors the move
    // in getStressAdrenalPanelMarkers.
    static STRESS_ADRENAL_FIELDS = [
        ...PanelField.ELECTROLYTES_FIELDS.filter(f => f.id === 'sodiumPotassiumRatio'),
        ...PanelField.ELECTROLYTES_FIELDS.filter(f => f.id === 'sodium' || f.id === 'potassium'),
        ...PanelField.HORMONE_FIELDS_1.filter(f => ['cortisolAM', 'cortisolPM', 'dheaS', 'pregnenolone'].includes(f.id)),
    ];

    static ALL_FIELDS = [
        ...PanelField.GENERAL_FIELDS,
        ...PanelField.CBC_FIELDS, 
        ...PanelField.WBC_ABSOLUTE_DIFFERENTIALS,
        ...PanelField.CMP_FIELDS,
        ...PanelField.LIPID_FIELDS,
        ...PanelField.IRON_FIELDS,
        ...PanelField.ADDITIONAL_FIELDS,
        ...PanelField.THYROID_FIELDS,
        ...PanelField.SEX_HORMONE_FIELDS,
        ...PanelField.PROSTATE_FIELDS,
        ...PanelField.IMMUNE_INFLAMMATORY_FIELDS,
        ...PanelField.MVX_FIELDS
    ];

    static PANEL_MARKER_FIELDS = [
        ...PanelField.CBC_FIELDS,
        ...PanelField.WBC_ABSOLUTE_DIFFERENTIALS,
        ...PanelField.CMP_FIELDS,
        ...PanelField.LIPID_FIELDS,
        ...PanelField.IRON_FIELDS,
        ...PanelField.ADDITIONAL_FIELDS,
        ...PanelField.THYROID_FIELDS,
        ...PanelField.SEX_HORMONE_FIELDS,
        ...PanelField.PROSTATE_FIELDS
    ];

    // The two Viscosity inputs (Hematocrit, then Total Protein), appended to the
    // Blood Clotting Function COMPARISON table after the coagulation markers so
    // the comparison report/PDF matches the analysis panel order
    // (getPlateletPanelMarkers). They are shown ONLY when the viscosity estimate
    // is present (which requires both inputs in the same test) — the component
    // gates on that, so a lone HCT/protein row never appears under coagulation.
    // HCT/protein also appear in their own sections (RBC / Proteins) —
    // intentional duplication, like Na/K showing in both Electrolytes and Adrenal.
    static PLATELETS_VISCOSITY_INPUT_FIELDS = [
        PanelField.findField(PanelField.ALL_FIELDS, 'hematocrit'),
        PanelField.findField(PanelField.ALL_FIELDS, 'protein'),
    ].filter(Boolean) as PanelField[];

    // Field list for the Blood Clotting Function COMPARISON table: coagulation
    // markers, plus the two viscosity inputs (Hematocrit, Total Protein) only
    // when the viscosity estimate is present (caller decides via
    // showViscosityInputs). Order matches the analysis panel.
    static plateletsComparisonFields(showViscosityInputs: boolean): PanelField[] {
        return showViscosityInputs
            ? [...PanelField.PLATELETS_FIELDS, ...PanelField.PLATELETS_VISCOSITY_INPUT_FIELDS]
            : [...PanelField.PLATELETS_FIELDS];
    }

    id: string;
    label: string;
    shortLabel?: string;
    precision?: number;
    placeholderPrecision?;
    placeholder?: string;
    absCellsPlaceholder?: string;
    absKCellsPlaceholder?: string;
    units?: string;
    chartUnits?: string;
    labCorpLink?: string;
    isWBCDifferential?: boolean;
    isAbsolute?: boolean;
    isHiddenForDisplay?: boolean;
    isHiddenFromComparison?: boolean;
    isNotEditable?: boolean;
    // Allow the reference-range panel's marker label to wrap to two lines
    // (for long names like "Viscosity - Estimated") instead of forcing a
    // single line that widens the label column and pushes the bars out.
    wrapChartLabel?: boolean;
    useRDWChart?: boolean; // TODO: Come up with a different name for this as well as RDW chart
    useEGFRChart?: boolean;
    useWBCPercentFromMean?: boolean; // TODO: Come up with better name
    noRedChart?: boolean;
    noRedOrangeChart?: boolean;
    isFormCheck?: boolean;

    static findField(fields: PanelField[], attribute: string): PanelField {
        if (!fields || !fields.length || !attribute) {
            return undefined;
        }
        
        return fields.find((panelField) => {
            return panelField.id === attribute;
        });
    }

    constructor(panelField?: PanelField) {
        if (!panelField) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(panelField).forEach(key => {
            this[key] = panelField[key];
        });
    }

    wbcPlaceholder?(wbcDiffUnitType: WhiteBloodCellDifferentialUnitType): string {
        switch (wbcDiffUnitType) {
            case WhiteBloodCellDifferentialUnitType.ABSOLUTE_CELLS:
                return this.absCellsPlaceholder;
            case WhiteBloodCellDifferentialUnitType.ABSOLUTE_KCELLS:
                return this.absKCellsPlaceholder;
            default:
                return this.placeholder;
        }
    }

    wbcUnits?(wbcDiffUnitType: WhiteBloodCellDifferentialUnitType): string {
        switch (wbcDiffUnitType) {
            case WhiteBloodCellDifferentialUnitType.ABSOLUTE_KCELLS:
                return 'k/mcL (x10E3/uL)';
            case WhiteBloodCellDifferentialUnitType.ABSOLUTE_CELLS:
                return 'cells/mcL (cells/uL)';
            default:
                return this.units as string;
        }
    }

    getChartLabel?(): string {
        return this.shortLabel ? this.shortLabel : this.label;
    }

    getChartUnits?(): string {
        return this.chartUnits ? this.chartUnits : this.units as string;
    }

    getPlaceholderPrecision?(): number {
        return this.placeholderPrecision != null ? this.placeholderPrecision : this.precision;
    }
}